/**
 * AddToCalendarButton — small contextual link/button that pre-populates
 * the calendar add-event dialog with sensible defaults for the current
 * page (dog / litter / transport order / etc).
 *
 * For now it just deep-links to /calendar with query params the
 * Calendar page reads on mount to auto-open the Add dialog with the
 * provided seed values. Keeps Calendar.jsx as the single source of
 * truth for the add flow.
 */
import React from "react";
import { Link } from "react-router-dom";
import { CalendarIcon as CalendarIcon } from "@phosphor-icons/react";

export default function AddToCalendarButton({
  // Optional seed values; all become URL query params.
  title = "",
  date = "",
  kind = "reminder",
  dogId = "",
  notes = "",
  variant = "subtle", // "subtle" | "primary"
  className = "",
  testId = "add-to-calendar-btn",
  label = "Add to calendar",
}) {
  const params = new URLSearchParams();
  if (title) params.set("seed_title", title);
  if (date) params.set("seed_date", date);
  if (kind) params.set("seed_kind", kind);
  if (dogId) params.set("seed_dog", dogId);
  if (notes) params.set("seed_notes", notes);
  params.set("add", "1");
  const href = `/calendar?${params.toString()}`;

  const styles =
    variant === "primary"
      ? "bg-[#0E0E0E] text-white hover:bg-[#1F1F1F]"
      : "border border-[#E5E5E5] text-[#6B6B6B] hover:text-[#0E0E0E] hover:border-[#0E0E0E]/40 bg-white";

  return (
    <Link
      to={href}
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${styles} ${className}`}
    >
      <CalendarIcon size={13} weight="duotone" />
      {label}
    </Link>
  );
}
